// src/locales/si/ecomOrders.js (Sinhala Translation)
export const ecomOrders = {
  // Page titles and navigation
  createNewOrder: 'නව Online Order එකක් සෑදීම',
  addNewOrderToSystem: 'නව e-commerce order එකක් පද්ධතියට එක් කරන්න',
  backToOrders: 'Orders වෙත ආපසු',
  allOrders: 'සියලු Online Orders',
  addOrder: 'Order එකක් එක් කරන්න',
  editOrder: 'Online Order සංස්කරණය',
  deleteOrder: 'Order මකන්න',
  viewOrderDetails: 'Order විස්තර බලන්න',

  // Form sections
  shopSelection: 'Shop තේරීම',
  customerInformation: 'පාරිභෝගික තොරතුරු',
  orderItems: 'Order items',
  orderStatusAndType: 'Order Status & Payment Type',
  paymentRecords: "ගෙවීම් වාර්තා",
  replacementOrders: 'Replacement Order විස්තර',
  orderSummary: 'Order සාරාංශය',

  // Shop selection
  selectShop: 'Shop තෝරන්න',
  selectShopRequired: 'කරුණාකර Shop එකක් තෝරන්න',
  shopSelectionDesc: 'මෙම order එක සඳහා shop එක තෝරන්න',
  currentShop: 'වත්මන් Shop',
  changeShop: 'Shop වෙනස් කරන්න',
  shopCannotBeChanged: 'Order එක once create කළ පසු shop cannot change',

  // Customer information
  customerName: 'පාරිභෝගික නම',
  customerNameRequired: 'පාරිභෝගික නම අවශ්‍යයි',
  customerNamePlaceholder: 'සම්පූර්ණ නම ඇතුල් කරන්න',

  privateReference: 'Private Reference',
  privateReferencePlaceholder: 'Internal reference (optional)',

  address: 'බෙදාහැරීමේ ලිපිනය',
  addressRequired: 'Delivery address අවශ්‍යයි',
  addressPlaceholder: 'සම්පූර්ණ delivery address ඇතුල් කරන්න',

  city: 'Delivery නගරය',
  cityRequired: 'Delivery city තෝරන්න',
  selectCity: 'Delivery city තෝරන්න',
  searchCity: "නගරය සොයන්න...",

  phoneNumbers: 'දුරකථන අංක',
  phoneNumbersRequired: 'අවම වශයෙන් එක් දුරකථන අංකයක් අවශ්‍යයි',
  phoneNumber: 'දුරකථන අංකය',
  phoneNumberPlaceholder: 'දුරකථන අංකය ඇතුලත් කරන්න',
  addPhoneNumber: 'අංකයක් එකතු කරන්න',
  removePhoneNumber: 'අංකය ඉවත් කරන්න',
  primaryPhone: 'මුලික',
  setPrimaryPhone: 'මුලික ලෙස සකසන්න',
  primaryPhoneRequired: 'මුලික අංකයක් සකසන්න',

  phoneLookupAutofilled: '{{source}} වෙතින් තොරතුරු ස්වයංක්‍රීයව පිරවිණ',
  phoneLookupSourcePos: 'POS පාරිභෝගිකයා',
  phoneLookupSourceOrder: 'පෙර ඇණවුම',

  customerEmail: 'Email',
  customerEmailPlaceholder: 'Email ඇතුල් කරන්න (Optional)',
  invalidEmailFormat: 'Email ආකෘතිය වැරදියි',

  deliveryNotes: 'Delivery Notes',
  deliveryNotesPlaceholder: 'Special instructions (optional)',

  specialNotes: 'Special Notes',
  specialNotesPlaceholder: 'Additional notes (optional)',

  // Order items
  searchProducts: 'Products සොයන්න',
  searchProductsPlaceholder: 'නම / SKU / Barcode අනුව සොයන්න...',
  addProduct: 'Product එකක් එක් කරන්න',
  noProductsFound: 'Products හමු නොවිණි',
  productRequired: 'Product එකක් තෝරන්න',

  product: 'Product',
  quantity: 'ප්‍රමාණය',
  quantityRequired: 'ප්‍රමාණය අවශ්‍යයි',
  quantityMinimum: 'ප්‍රමාණය අවම වශයෙන් 1 විය යුතුය',

  unitPrice: 'Unit Price',
  unitPriceRequired: 'Unit Price අවශ්‍යයි',
  unitPriceMinimum: 'Unit Price 0 ට වැඩි විය යුතුය',

  lineDiscount: 'Discount',
  lineDiscountPlaceholder: 'Discount (optional)',
  lineDiscountMaximum: 'Discount එක line total ට වඩා cannot',

  lineTotal: 'Line Total',
  removeItem: 'Item එක මකන්න',

  atLeastOneItemRequired: 'අවම වශයෙන් item 1ක් අවශ්‍යයි',

  // Product search results
  productResults: 'Product Results',
  selectProduct: 'Product තෝරන්න',
  productSku: 'SKU',
  productStock: 'Stock',
  productPrice: 'Price',
  productAttributes: 'Attributes',

  // Order status and payment
  orderStatus: 'Order Status',
  orderStatusRequired: 'Order Status තෝරන්න',

  statusReason: 'Status Reason',
  statusReasonRequired: 'මෙම Status සඳහා Reason අවශ්‍යයි',
  selectStatusReason: 'Reason තෝරන්න',

  holdUntilDate: 'Hold Until Date',
  holdUntilDateRequired: 'Date අවශ්‍යයි',

  paymentType: "ගෙවීම් වර්ගය",
  paymentTypeRequired: "කරුණාකර ගෙවීම් වර්ගය තෝරන්න",
  paymentTypeLockedHint: 'ගෙවීමක් තහවුරු කළ පසු ගෙවීම් වර්ගය වෙනස් කළ නොහැක',
  editPaymentsAndShift: 'ගෙවීම් සහ Shift',
  selectPaidPaymentTypeFirst: 'ගෙවීම් එක් කිරීමට Fully Paid හෝ Partially Paid තෝරන්න',
  outstandingBalance: 'හිඟ ශේෂය',
  confirmPayment: 'ගෙවීම තහවුරු කරන්න',
  paymentRecordedSuccess: 'ගෙවීම සාර්ථකව සටහන් විය',
  failedToRecordPayment: 'ගෙවීම සටහන් කිරීම අසාර්ථකයි',
  confirmDeletePaymentRecord: 'තහවුරු නොකළ මෙම ගෙවීම් වාර්තාව මකන්නද?',
  messageCenterShift: 'Message Center Shift',
  saveShift: 'Shift සුරකින්න',
  shiftUpdatedSuccess: 'Shift සාර්ථකව යාවත්කාලීන විය',
  paymentTypeUpdatedSuccess: 'ගෙවීම් වර්ගය සාර්ථකව යාවත්කාලීන විය',

  // Replacement orders
  replacedOrderId: 'Original Order Number',
  replacedOrderIdRequired: 'Original Order Number අවශ්‍යයි',
  replacedOrderIdPlaceholder: 'Original order number',

  replacementReason: 'Replacement යෙදුමේ හේතුව',
  replacementReasonRequired: 'Reason අවශ්‍යයි',
  selectReplacementReason: 'Reason තෝරන්න',

  returnAirwaybillNumber: 'Return Airwaybill අංකය',
  returnAirwaybillNumberPlaceholder: 'Return parcel airwaybill අංකය ඇතුළත් කරන්න (අත්‍යවශ්‍ය නොවේ)',
  itemsToReturn: 'ආපසු ලබාදෙන අයිතම',
  item: 'අයිතමය',
  remainingReturnableQty: 'ආපසු දිය හැකි ඉතිරි ප්‍රමාණය',
  returnQuantity: 'ආපසු ලබාදෙන ප්‍රමාණය',
  returnQuantityExceedsRemaining: 'ආපසු ලබාදෙන ප්‍රමාණය ඉතිරි ප්‍රමාණයට වඩා වැඩිය',
  returnPackageOrder: 'Return Package Order එක',
  returnPackageOrderCreated: 'Return package order එක සාදන ලදී',

  // Payment records
  paymentRecordsRequired: "මෙම ගෙවීම් වර්ගය සඳහා ගෙවීම් වාර්තා අවශ්‍යයි",
  paymentRecordsOptional: "මෙම ගෙවීම් වර්ගය සඳහා ගෙවීම් වාර්තා විකල්පයකි",
  addPaymentRecord: "ගෙවීම් වාර්තාවක් එක් කරන්න",
  removePaymentRecord: "ගෙවීම් වාර්තාව ඉවත් කරන්න",

  paymentMethod: 'ගෙවීමේ ක්‍රමය',
  paymentMethodRequired: "ගෙවීම් ක්‍රමය අවශ්‍යයි",
  selectPaymentMethod: "ගෙවීම් ක්‍රමය තෝරන්න",

  paymentAmount: "ගෙවීම් මුදල",
  paymentAmountRequired: "ගෙවීම් මුදල අවශ්‍යයි",
  paymentAmountMinimum: "ගෙවීම් මුදල 0 ට වඩා වැඩි විය යුතුය",

  paymentReference: "ගෙවීම් යොමුව",
  paymentReferencePlaceholder: 'Receipt / Transaction No.',

  paymentDate: "ගෙවීම් දිනය",
  paymentDateRequired: "ගෙවීම් දිනය අවශ්‍යයි",

  totalPaid: 'Paid මුදල',
  paymentBalance: "ශේෂය",
  codToCollect: "එකතු කළ යුතු COD",
  overpaidAmount: "වැඩිපුර ගෙවූ මුදල",

  // Order summary and calculations
  subtotal: 'Subtotal',
  totalDiscount: 'Total Discount',
  deliveryCharge: 'Delivery Charge',
  tax: 'Tax',
  grandTotal: 'Grand Total',

  // Delivery charges
  calculatingDeliveryCharge: 'Delivery charge ගණනය කරමින්...',
  deliveryChargeCalculated: 'Delivery charge ගණනය කරයි',
  deliveryNotAvailable: 'මෙම ලිපිනට delivery නැත',
  deliveryChargeFailed: 'Delivery charge ගණනය කිරීම අසාර්ථකයි',

  // Form actions
  createOrder: 'Order Create කරන්න',
  updateOrder: 'Order Update කරන්න',
  saveOrder: 'Order Save කරන්න',
  cancel: 'Cancel',

  // Success messages
  orderCreatedSuccess: 'Order "{{orderNumber}}" සාර්ථකව සෑදුවා!',
  orderUpdatedSuccess: 'Order update විය',
  orderSavedSuccess: 'Order save විය',

  // Error messages
  failedToCreateOrder: 'Order create cannot. නැවත උත්සාහ කරන්න.',
  failedToUpdateOrder: 'Order update cannot. නැවත උත්සාහ කරන්න.',
  failedToLoadOrder: 'Order විස්තර load cannot.',
  failedToLoadReferenceData: 'අවශ්‍ය data load cannot. Page refresh කරන්න.',

  someFieldsRequired: 'අවශ්‍ය fields පුරවන්න',
  invalidOrderData: 'Order data වල දෝෂ ඇත',
  noChangesDetected: 'වෙනස්කම් හමු නොවීය',

  // Loading states
  loadingReferenceData: 'අයදුම් data load වෙමින්...',
  loadingOrder: 'Order load වෙමින්...',
  savingOrder: 'Order save වෙමින්...',
  calculatingTotals: 'ගණනය කරමින්...',

  // Validation messages
  required: 'අවශ්‍යයි',
  optional: 'Optional',
  invalidPhoneNumber: 'අවිනිවිදිත දුරකථන අංකය',
  duplicatePhoneNumber: 'දුරකථන අංකය දැනටමත් ඇත',

  // Permission errors
  insufficientPermissions: 'ඔබට මෙම ක්‍රියාව කිරීමට අවසර නැත',
  cannotChangeUnitPrice: 'Unit price වෙනස් cannot',
  cannotGiveDiscount: 'Discount cannot',
  cannotChangeDeliveryCharge: 'Delivery charge cannot change',

  // Order number
  orderNumber: 'Order Number',
  orderNumberPreview: 'Order Number Preview',
  generatedOrderNumber: 'Generated Order Number',

  // Order list
  ordersList: 'Orders List',
  searchOrders: 'Orders සොයන්න...',
  filterByStatus: 'Status අනුව Filter',
  filterByPaymentType: "ගෙවීම් වර්ගය අනුව පෙරහන් කරන්න",
  filterByShop: 'Shop අනුව Filter',
  filterByCity: 'City අනුව Filter',

  noOrdersFound: 'Orders සොයාගත cannot',
  noOrdersYet: 'Orders නොමැත',

  // Date filters
  today: '今日',
  yesterday: 'ඊයේ',
  thisWeek: 'මෙම සතිය',
  thisMonth: 'මෙම මාසය',

  // Order statuses
  pending: 'Pending',
  confirmed: 'Confirmed',
  hold: 'Hold',
  notConfirmed: 'Not Confirmed',
  cancelled: 'Cancelled',
  inCourier: 'Courier හිදී',
  settled: 'Settled',
  returned: 'Returned',

  // Payment types
  cashOnDelivery: 'Cash On Delivery',
  fullyPaid: 'Full Paid',
  partiallyPaid: "අර්ධ වශයෙන් ගෙවා ඇත",
  replacement: 'Replacement',

  // Payment methods
  cash: 'Cash',
  bankTransfer: 'Bank Transfer',
  cheque: 'Cheque',
  cardPayment: "කාඩ්පත් ගෙවීම",

  // Common UI
  loading: 'Load වෙමින්...',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  reset: 'Reset',

  // Keyboard navigation
  enterToSelect: 'Select කිරීමට Enter ඔබන්න',
  escapeToClose: 'වහීමට Escape',
  arrowKeysToNavigate: 'Navigate කිරීමට Arrow keys භාවිතා කරන්න',

  // Accessibility
  selectOption: 'Option තෝරන්න',
  selectedOption: 'තෝරාගත් option',
  optionsAvailable: '{{count}} option(s) ඇත',
  noOptionsAvailable: 'Option නොමැත',

  // Bulk Order Creation
  bulkOrderCreate: 'Bulk Orders සෑදීම',
  bulkOrderCreateDesc: 'Excel Upload කර orders කිහිපයක් එක් වරක් create කරන්න',
  downloadTemplate: 'Template Download කරන්න',
  uploadFile: 'File Upload කරන්න',
  validateOrders: 'Orders Validate කරන්න',
  submitOrders: 'Orders Submit කරන්න',
  submitValidOrders: '{{count}} Valid Orders Submit කරන්න',
  retryValidation: 'Fix & Revalidate',
  clearAll: 'සියල්ල Clear කරන්න',

  // File Upload
  dragDropFile: 'Excel File drag & drop කරන්න',
  orClickToSelect: 'හෝ file තෝරන්න',
  supportedFormats: 'Support formats: .xlsx, .csv',
  fileUploaded: 'File upload විය',
  fileName: 'File නම',
  rowCount: '{{count}} rows',
  removeFile: 'File remove',

  // Data Preview
  dataPreview: 'Data Preview',
  showingRows: '{{count}} orders පෙන්වයි',
  validRows: '{{count}} Valid',
  invalidRows: '{{count}} Invalid',
  editRow: 'Row Edit',
  deleteRow: 'Row Delete',

  // Validation
  validating: 'Orders Validate වෙමින්...',
  validationComplete: 'Validation අවසන්',
  validationErrors: 'Validation Errors ඇත',
  validOrder: 'Valid Order',
  invalidOrder: 'Invalid Order',
  validationDetails: 'Validation විස්තර',

  // Submission
  submitting: 'Orders submit වෙමින්...',
  submissionComplete: 'Submit අවසන්',
  ordersCreatedSuccessfully: '{{count}} Orders සෑදුවා',
  ordersFailed: '{{count}} Orders Failed',
  viewCreatedOrders: 'Created Orders බලන්න',
  createMoreOrders: 'තවත් Orders Create කරන්න',

  // Progress
  processingOrders: 'Orders Process වෙමින්...',
  validatingOrder: '{{total}} න් {{current}} වන Order Validate වෙමින්...',
  creatingOrder: '{{total}} න් {{current}} වන Order Create වෙමින්...',

  // Errors
  noShopSelected: 'Shop තෝරන්න',
  noFileUploaded: 'File upload කර නොමැත',
  invalidFileFormat: 'වලංගු File format නොවේ (.xlsx / .csv)',
  fileParsingError: 'File read cannot',
  noOrdersFound: 'File එකේ Orders නොමැත',
  validationFailed: 'Validation Failed. Errors සකස් කරන්න',
  submissionFailed: 'කෙටි Orders Failed. Results පරීක්‍ෂා කරන්න',

  // Column Names
  columnCustomerName: 'Customer Name',
  columnCustomerEmail: 'Email',
  columnAddress: 'Address',
  columnPhone1: 'Phone 1',
  columnPhone2: 'Phone 2',
  columnCityName: 'City Name',
  columnPaymentType: "ගෙවීම් වර්ගය",
  columnOrderStatus: 'Order Status',
  columnPrivateReference: 'Private Reference',
  columnDeliveryNotes: 'Delivery Notes',
  columnSpecialNotes: 'Special Notes',
  columnItemSku: 'Item {{number}} SKU',
  columnItemQuantity: 'Item {{number}} Qty',
  columnItemCustomLineTotal: 'Item {{number}} Custom Line Total',
  columnDeliveryCharge: 'Delivery Charge',
  columnTotalDiscount: 'Total Discount',

  // Table Headers
  row: 'Row',
  status: 'Status',
  customer: 'Customer',
  items: 'Items',
  total: 'Total',
  errors: 'Errors',
  actions: 'Actions',

  // Order list page - MISSING SECTION
  totalOrders: 'සම්පූර්ණ Orders',
  allShops: 'සියලුම Shops',
  allCities: 'සියලුම Cities',
  allStatuses: 'සියලුම Statuses',
  allPaymentTypes: "සියලුම ගෙවීම් වර්ග",
  fromDate: 'පටන් දිනය',
  toDate: 'අවසන් දිනය',
  viewManageOrders: 'සියලුම e-commerce orders බලන්න සහ කළමනාකරණය කරන්න',
  searchOrdersPlaceholder: 'Order number, airwaybill number, customer name, phone, හෝ private reference අනුව සොයන්න... (බහු අගයන් paste කරන්න)',
  loadingOrders: 'Orders load වන තුරු රැඳී සිටින්න...',
  unableToLoadOrders: 'Orders Load කළ නොහැක',
  noOrdersFoundDescription: 'ඔබගේ සෙවුම් නිර්ණායකයන්ට ගැලපෙන orders නොමැත',
  startCreatingOrders: 'ඔබගේ පළමු order එක සෑදීමෙන් ආරම්භ කරන්න',
  courier: 'Courier',
  shop: 'Shop',
  products: 'Products',
  
  // Order details modal - MISSING SECTION
  orderDetails: 'Order විස්තර',
  shopName: 'Shop නම',
  courierInformation: 'Courier තොරතුරු',
  airwaybillNumber: 'Airwaybill Number',
  courierName: 'Courier නම',
  courierStatus: 'Courier Status',
  additionalInformation: 'අමතර තොරතුරු',
  updatedAt: 'Update කළ දිනය',
  createdAt: 'සෑදූ දිනය',
  createdBy: 'සෑදූ පුද්ගලයා',
  confirmedBy: 'තහවුරු කළ පුද්ගලයා',
  confirmedAt: 'තහවුරු කළ දිනය',
  
  // Order Details Page (NEW) - MISSING SECTION
  currentStatus: 'වත්මන් Status',
  trackingDetails: 'Tracking විස්තර',
  packageTimeline: 'Package Timeline',
  codValue: 'COD Value',
  totalCourierFees: 'සම්පූර්ණ Courier Fees',
  courierStatusUpdatedAt: 'Courier Status Update කළ දිනය',
  paidAmount: 'ගෙවූ මුදල',
  codAmount: 'COD මුදල',
  dispatchedDate: 'Dispatch කළ දිනය',
  shiftDate: 'Shift Date',
  shiftType: 'Shift Type',
  allShiftTypes: 'All shift types',

  // Audit History (NEW) - MISSING SECTION
  auditHistory: 'වෙනස්කම් ඉතිහාසය',
  totalChanges: 'සම්පූර්ණ වෙනස්කම්',
  lastModified: 'අවසන් වෙනසක් කළ දිනය',
  modifiedBy: 'වෙනස් කළ පුද්ගලයා',
  noAuditHistory: 'වෙනස්කම් ඉතිහාසයක් නොමැත',
  failedToLoadAuditHistory: 'Audit history load කළ නොහැකි විය',
  
  // Courier Tracking (NEW) - MISSING SECTION
  failedToLoadCourierTracking: 'Courier tracking තොරතුරු load කළ නොහැකි විය',
  loadingTracking: 'Tracking තොරතුරු load වෙමින්...',
  noTrackingEvents: 'තවම tracking සිදුවීම් නැත',
  latest: 'නවතම',
  viewPackageTimeline: 'පැකේජ timeline බලන්න',

  // Actions (NEW) - MISSING SECTION
  show: 'පෙන්වන්න',
  hide: 'සඟවන්න',
  
  // Call Attempts (NEW) - MISSING SECTION
  callAttempts: 'Call උත්සාහයන්',

  // Related Documents - MISSING SECTION
  relatedDocuments: 'සම්බන්ධිත Documents',
  packingBatches: 'Packing Batches',
  returnBatches: 'Return Batches',
  courierInvoices: 'Courier Invoices',
  failedToLoadRelations: 'සම්බන්ධිත documents load කළ නොහැකි විය',

  // Filter labels - MISSING SECTION
  allBusinessCouriers: 'සියලුම Business Couriers',
  businessCourier: 'Business Courier',
  allCourierStatuses: 'සියලුම Courier Statuses',

  // Permission errors - MISSING SECTION
  noPermissionEditDispatchedOrders: 'Dispatch කළ orders edit කිරීමට ඔබට අවසර නැත',
  noPermissionEditInPackingOrders: 'Packing වෙමින් තිබෙන orders edit කිරීමට ඔබට අවසර නැත',

  // Weight
  weight: 'බර',
  weightKg: 'බර (kg)',

  // Order Origin
  orderOrigin: 'Order Origin',
  paid: "ගෙවා ඇත",
  organic: 'Organic',
  viewShift: "මාරුව බලන්න",

  // Export
  exportConfirmTitle: "ඇණවුම් අපනයනය",
  exportConfirmMessage: "වත්මන් පෙරහන්වලට ගැළපෙන ඇණවුම් {{count}} ක් CSV වෙත අපනයනය කරන්නද?",
  exportCapNote: "පළමු ඇණවුම් {{max}} පමණක් අපනයනය කෙරේ.",
  exportingOrders: "ඇණවුම් අපනයනය කරමින්",
  noOrdersToExport: "වත්මන් පෙරහන් සමඟ අපනයනය කිරීමට ඇණවුම් නැත.",
  exportAlreadyRunning: "අපනයනයක් දැනටමත් ක්‍රියාත්මකයි. එය අවලංගු කරන්න හෝ අවසන් වන තෙක් රැඳී සිටින්න.",
  exportCompleteBackground: "අපනයනය සම්පූර්ණයි. ඔබගේ ගොනුව බාගත කර ඇත.",

  // Shop change
  shopChangeTitle: "සාප්පුව වෙනස් කරන්න",
  shopChangeClearsItems: "සාප්පුව වෙනස් කිරීමෙන් තෝරාගත් ඇණවුම් අයිතම ඉවත් වේ. ඉදිරියට යන්නද?",

  // Payment Proof
  paymentProof: "ගෙවීම් සාක්ෂිය",
  uploadProof: "සාක්ෂිය උඩුගත කරන්න",
  changeProof: "වෙනස් කරන්න",
  viewProofPdf: "උඩුගත කළ PDF බලන්න",
  invalidProofFormat: ".jpg, .png හෝ .pdf ගොනු පමණක් අවසර ඇත",
  proofTooLarge: "ගොනුව 5MB ට අඩු විය යුතුය",
  proofUploadFailed: "උඩුගත කිරීම අසමත් විය, කරුණාකර නැවත උත්සාහ කරන්න",

  // Cross Sell
  crossSellItem: 'Cross Sell Item',
  bundle: 'පැකේජය',
  bundleQuantity: 'පැකේජ ප්‍රමාණය',
  bundleComponents: 'පැකේජයේ අයිතම',
  bundleTotal: 'පැකේජ එකතුව',
  free: 'නොමිලේ',
  removeBundle: 'පැකේජය ඉවත් කරන්න',
  crossSellBundles: 'Cross Sell (පැකේජ)',
  crossSellQuantity: 'Cross sold qty',

  // Message Center Shift
  selectDate: 'Select date',
  selectShift: 'Select shift',
  noShiftsForDate: 'No shifts for date',
  rememberShift: 'මතක තබාගන්න',
  rememberShiftHint: 'මෙම මුර වාරය මතක තබාගෙන, ඊළඟ වතාවේදී ස්වයංක්‍රීයව load කරන්න',
  paymentRecordsNotRequired: "ගෙවීම් වාර්තා අවශ්‍ය නොවේ",
  paymentRecordsNotRequiredHint: "ගෙවීම් වාර්තා අවශ්‍ය වන්නේ \"සම්පූර්ණයෙන් ගෙවූ\" හෝ \"අර්ධ වශයෙන් ගෙවූ\" ගෙවීම් වර්ග සඳහා පමණි.",
  verifiedPaymentRecord: "තහවුරු කර ඇත",
  paymentRecordChange: "ගෙවීම් වාර්තාව",
  auditItemAdded: "අයිතමය එක් කළා",
  auditItemRemoved: "අයිතමය ඉවත් කළා",
  auditItemUpdated: "අයිතමය යාවත්කාලීන කළා",
  auditBundleTag: "බණ්ඩලය: {{name}}",
  invalidPaymentType: "වලංගු නොවන ගෙවීම් වර්ගය",
  paymentRecordNumber: "ගෙවීම් වාර්තාව #{number}",
  paymentSummary: "ගෙවීම් සාරාංශය",
  orderTotal: "ඇණවුම් එකතුව",
  paymentOverpaid: "වැඩිපුර ගෙවා ඇත",
  paymentFullyPaid: "සම්පූර්ණයෙන් ගෙවා ඇත",
  paymentPending: "ගෙවීම අපේක්ෂිතයි",
  noRemainingBalance: "ගෙවීම් වාර්තාවක් එක් කිරීමට ඉතිරි ශේෂයක් නැත",
  orderFieldSettings: "ක්ෂේත්‍ර සැකසුම්",
  orderFieldSettingsDescription: "ඇණවුමක් සාදන විට හෝ සංස්කරණය කරන විට අවශ්‍ය ක්ෂේත්‍ර තෝරන්න.",
  enableFieldRequirements: "අවශ්‍ය ක්ෂේත්‍ර අභිරුචිකරණය කරන්න",
  enableFieldRequirementsHelp: "අක්‍රිය විට, මෙම සියලු ක්ෂේත්‍ර විකල්ප වේ",
  fieldRequired: "අවශ්‍යයි",
  fieldOptional: "විකල්ප",
  orderFieldSettingsSaved: "ඇණවුම් ක්ෂේත්‍ර සැකසුම් සුරකින ලදී",
  orderFieldSettingsSaveFailed: "ඇණවුම් ක්ෂේත්‍ර සැකසුම් සුරැකීම අසාර්ථකයි",
  privateReferencePlaceholderRequired: "Internal reference",
  customerEmailPlaceholderRequired: "Email ඇතුල් කරන්න",
  deliveryNotesPlaceholderRequired: "Special instructions",
  specialNotesPlaceholderRequired: "Additional notes",
  clientRemarks: "පාරිභෝගික සටහන්",
  validation: {
    shopRequired: "කඩය තේරීම අවශ්‍යයි",
    customerNameRequired: "පාරිභෝගිකයාගේ නම අවශ්‍යයි",
    addressRequired: "බෙදාහැරීමේ ලිපිනය අවශ්‍යයි",
    cityRequired: "බෙදාහැරීමේ නගරය අවශ්‍යයි",
    phoneRequired: "අවම වශයෙන් එක් දුරකථන අංකයක් අවශ්‍යයි",
    primaryPhoneRequired: "කරුණාකර එක් දුරකථන අංකයක් ප්‍රධාන ලෙස සකසන්න",
    privateReferenceRequired: "පුද්ගලික යොමුව අවශ්‍යයි",
    customerEmailRequired: "පාරිභෝගික ඊමේල් අවශ්‍යයි",
    deliveryNotesRequired: "බෙදාහැරීමේ සටහන් අවශ්‍යයි",
    specialNotesRequired: "විශේෂ සටහන් අවශ්‍යයි",
    orderOriginRequired: "ඇණවුම් මූලාශ්‍රය අවශ්‍යයි",
    invalidEmail: "වලංගු නොවන ඊමේල් ආකෘතියකි",
    orderItemsRequired: "අවම වශයෙන් එක් ඇණවුම් අයිතමයක් අවශ්‍යයි",
    quantityInvalid: "ප්‍රමාණය 0 ට වඩා වැඩි විය යුතුය",
    unitPriceInvalid: "ඒකක මිල 0 ට වඩා වැඩි විය යුතුය",
    discountNegative: "වට්ටම සෘණ විය නොහැක",
    discountExceedsLine: "වට්ටම පේළි වටිනාකම ඉක්මවිය නොහැක",
    deliveryChargeNegative: "බෙදාහැරීමේ ගාස්තුව සෘණ විය නොහැක",
    duplicatePhone: "මෙම දුරකථන අංකය දැනටමත් එක් කර ඇත",
    orderStatusRequired: "ඇණවුම් තත්ත්වය අවශ්‍යයි",
    paymentTypeRequired: "ගෙවීම් වර්ගය අවශ්‍යයි",
    statusReasonRequired: "මෙම තත්ත්වය සඳහා හේතුව අවශ්‍යයි",
    holdDateRequired: "මෙම තත්ත්වය සඳහා රඳවා තබන දිනය අවශ්‍යයි",
    replacedOrderRequired: "ප්‍රතිස්ථාපන ඇණවුම් සඳහා මුල් ඇණවුම් අංකය හෝ airwaybill අවශ්‍යයි",
    orderLookupPending: "ඇණවුම සොයන තෙක් රැඳී සිටින්න",
    validReplacedOrderRequired: "වලංගු ඇණවුම් අංකයක් හෝ airwaybill අවශ්‍යයි",
    replacementReasonRequired: "ප්‍රතිස්ථාපන හේතුව අවශ්‍යයි",
    replacementCodRequired: "ප්‍රතිස්ථාපන ඇණවුම් සඳහා COD මුදල අවශ්‍යයි",
    replacementCodNegative: "COD මුදල 0 හෝ ඊට වැඩි විය යුතුය",
    replacementCodExceeds: "COD මුදල මුළු එකතුව ඉක්මවිය නොහැක",
    returnQtyExceeds: "එක් හෝ වැඩි අයිතම සඳහා ආපසු ප්‍රමාණය ඉතිරි ආපසු දිය හැකි ප්‍රමාණය ඉක්මවයි",
    paymentRecordsRequired: "මෙම ගෙවීම් වර්ගය සඳහා ගෙවීම් වාර්තා අවශ්‍යයි",
    paymentMethodRequired: "ගෙවීම් ක්‍රමය අවශ්‍යයි",
    paymentAmountInvalid: "ගෙවීම් මුදල 0 ට වඩා වැඩි විය යුතුය",
    paymentDateRequired: "ගෙවීම් දිනය අවශ්‍යයි",
    fullyPaidIncomplete: "ගෙවීම අසම්පූර්ණයි. සම්පූර්ණයෙන් ගෙවූ ඇණවුම් සඳහා ගෙවූ මුළු මුදල ({{totalPaid}}) මුළු එකතුවට ({{grandTotal}}) සමාන විය යුතුය.",
    fullyPaidOverpaid: "ඇණවුම සඳහා වැඩිපුර ගෙවා ඇත. සම්පූර්ණයෙන් ගෙවූ ඇණවුම් සඳහා ගෙවූ මුළු මුදල ({{totalPaid}}) මුළු එකතුවට ({{grandTotal}}) සමාන විය යුතුය.",
    partiallyPaidInvalid: "අර්ධ වශයෙන් ගෙවූ ඇණවුම් සඳහා, ගෙවූ මුළු මුදල ({{totalPaid}}) මුළු එකතුවට ({{grandTotal}}) වඩා අඩු විය යුතුය.",
  },
};
